import { FIND_GROUPED_QUESTIONS_BY_SECTION_USE_CASE, FindGroupQuestionsBySectionUseCase, QUESTION_REPOSITORY, FIND_QUESTION_RELEASES_USE_CASE, FindQuestionReleasesUseCase, QUESTION_RELEASES_REPOSITORY } from '@module/form';
export var questionUseCaseProviders = [{
  provide: FIND_GROUPED_QUESTIONS_BY_SECTION_USE_CASE,
  useFactory: function useFactory(questionRepository) {
    return new FindGroupQuestionsBySectionUseCase(questionRepository);
  },
  inject: [QUESTION_REPOSITORY]
}, {
  provide: FIND_QUESTION_RELEASES_USE_CASE,
  useFactory: function useFactory(questionReleasesRepository) {
    return new FindQuestionReleasesUseCase(questionReleasesRepository);
  },
  inject: [QUESTION_RELEASES_REPOSITORY]
}];